/**
 * Test an object expected to be an Array
 * @param arr (any) 
 * @return boolean If object is not defined, not an Array, or has no items
 */
export function isEmpty(arr: any) {
    return (!arr || !Array.isArray(arr) || !arr.length);
}




// WEBPACK FOOTER //
// ./src/util.ts